import name from '../router/name'
const adminConfig = [
    {
        menu: '基本业务',
        key: 'applicationManage',
        icon: 'file',
        childen: [
            {
                subMenu: '订单管理',
                routerName: name.buy,
                subKey: name.buy
            }
        ]
    }
]
export default adminConfig;